module.exports = __webpack_public_path__ + "a1d985dd.svg";